import { pick } from 'lodash-es';
import { useApi2call } from 'containers/Api2/index.js';
import { MEETING_ALL_FIELDS } from '../constants.js';
import parseSet from './parseSet.js';
import { LOCATION_TYPE_PREMISES } from '../Planner/SelectLocationType/constants.js';

function useSaveMeetingSet() {
  const api2call = useApi2call();
  return (set) => {
    const body = pick({ ...set, meetingLocationType: Number(set.meetingLocationType) || LOCATION_TYPE_PREMISES }, MEETING_ALL_FIELDS);
    delete body.meetings;
    delete body.blocks;
    // TODO need to getvalues / stringify videoInfo?
    const options = {
      method: set.id ? 'PUT' : 'POST',
      url: set.id ? `meetings/sets/${set.id}` : 'meetings/sets',
      body,
      parser: parseSet,
      withPromise: true,
      noReport: [409],
    };
    return api2call(options);
  };
}

export default useSaveMeetingSet;
